module.exports = __webpack_public_path__ + "static/media/18ECA3.a6d0d09e.jpg";